import apiClient, { LONG_TIMEOUT } from 'commons/api/client/apiClient';

export default {
  getFormData(obj) {
    return Object.keys(obj).reduce((formData, key) => {
      formData.append(key, obj[key]);
      return formData;
    }, new FormData());
  },
  upload(options = {}) {
    return apiClient.request({
      // Before the spread, so a caller can still raise it further.
      timeout: LONG_TIMEOUT,
      ...options,
      method: 'POST',
      url: options.url,
      uploadEventHandlers: {
        progress: options.onUploadProgress || (() => {}),
      },
      data: this.getFormData(options.data),
      headers: { 'Content-Type': undefined },
    });
  },
  uploadAsBuffer(options = {}) {
    const fileData = options.data.filedata;

    return fileData.arrayBuffer().then((buffer) => {
      return apiClient.request({
        timeout: LONG_TIMEOUT,
        ...options,
        method: 'POST',
        url: options.url,
        headers: {
          'Content-Type': fileData.type || 'application/octet-stream',
        },
        uploadEventHandlers: {
          progress: options.onUploadProgress || (() => {}),
        },
        data: buffer,
      });
    });
  },
};
